import { useEffect, useState } from "react";
import {
  Input,
  Form,
  Modal,
  Typography,
  Row,
  Col,
  InputNumber,
} from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";
import DigitsDatePicker from "@/components/inputs/DigitsDatePicker";

import { createRecord, updateRecord } from "@/api/workrecords";
import { getEmployeesOptions, getItem as getEmployee } from "@/api/employees";

const { Text } = Typography;
// Окно для создания/редактирования времени в табеле
const TimeTrackingModal = ({ data, visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [employeeList, setEmployeeList] = useState([]);

  const fetchUserList = async () => {
    try {
      const { employees } = await getEmployeesOptions({ is_dismissed: false });

      setEmployeeList(
        employees.map((item) => {
          const { lastname, firstname, patronymic } = item.employee;
          return {
            ...item.employee,
            label: `${lastname || ""} ${firstname || ""} ${patronymic || ""}`,
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (record) => {
    setError(null);
    setIsLoading(true);

    try {
      const { employee } = await getEmployee(record.employee_uuid);

      const res = {
        worked_hours: record.worked_hours,
        work_date: record.work_date.format().split("T")[0],
        unit_uuid: employee.unit_uuid,
        employee_uuid: record.employee_uuid,
        description: record.description,
      };
      delete res.employee;

      if (!!data.uuid) {
        await updateRecord({ ...res, uuid: data.uuid });
      } else {
        await createRecord(res);
      }
      onSave();

      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () =>
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });

  return (
    <Modal
      maskClosable={false}
      title={data?.uuid ? "Запись о работе" : "Новая запись о работе"}
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText={data?.uuid ? "Сохранить" : "Добавить"}
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSave}
      >
        <Form.Item
          name="employee_uuid"
          label="Сотрудник"
          rules={[
            { required: true, message: "Пожалуйста, выберите сотрудника" },
          ]}
        >
          <CustomSelect
            placeholder="Начните вводить"
            options={employeeList}
            showSearch
            allowClear
            fieldNames={{ value: "uuid" }}
            optionFilterProp="label"
            disabled={data?.uuid}
          />
        </Form.Item>

        <Form.Item name="description" label="Описание">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Row>
          <Col span={12}>
            <Form.Item
              name="work_date"
              label="Дата"
              rules={[{ required: true, message: "Пожалуйста, выберите дату" }]}
            >
              <DigitsDatePicker disabled={data?.uuid} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="worked_hours"
              label="Время (ч)"
              rules={[
                { required: true, message: "Пожалуйста, выберите время " },
              ]}
            >
              <InputNumber min={0} max={24} />
            </Form.Item>
          </Col>
        </Row>
        {error && <Text type="danger">{error}</Text>}
      </Form>
    </Modal>
  );
};

export default TimeTrackingModal;
